import { LOGIN_FORM_FORCE_LOGIN_REFRESH, LOGIN_FORM_RESET, LOGIN_FORM_SET_PASSWORD, LOGIN_FORM_SET_USERNAME } from "../../constants"

import { fromJS } from "immutable"

const INITIAL_STATE = fromJS({
	loginData: {},
})

function loginReducer(
	state = INITIAL_STATE,
	action = {
		type: "",
		payload: null
	}
) {
	switch (action.type) {
		case LOGIN_FORM_RESET:
			return state.merge(
				fromJS({
					loginData: state.get("loginData").merge(
						fromJS({
							username: "",
							password: "",
						})
					),
				})
			)
		case LOGIN_FORM_FORCE_LOGIN_REFRESH:
			return state.merge(
				fromJS({
					loginData: state.get("loginData").merge(
						fromJS({
							username: "",
							password: "",
						})
					),
				})
			)

		case LOGIN_FORM_SET_USERNAME:
			return state.merge(
				fromJS({
					loginData: state.get("loginData").merge(
						fromJS({
							username: action.payload,
						})
					),
				})
			)

		case LOGIN_FORM_SET_PASSWORD:
			return state.merge(
				fromJS({
					loginData: state.get("loginData").merge(
						fromJS({
							password: action.payload,
						})
					),
				})
			)

		default:
			return state
	}
}

export default loginReducer
